import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
import { SOFTWARE_PRODUCTS } from "@/data/site";

const STAGE_COLOR = {
  Development: "border-[#0066FF]/40 text-[#0066FF]",
  Prototype: "border-[#C8961F]/40 text-[#C8961F]",
  Portfolio: "border-slate-300 text-slate-700",
  Concept: "border-slate-200 text-slate-500",
};

export default function SoftwarePortfolio() {
  return (
    <>
      <section className="pt-32 pb-16 md:pt-40 relative" data-testid="software-portfolio-page">
        <div className="absolute inset-0 grid-bg radial-mask opacity-40" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="eyebrow mb-4">// Software Stack</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-slate-900 max-w-4xl">
            Platforms, concepts, and properties — all in active orbit.
          </h1>
          <p className="mt-6 text-base md:text-lg text-slate-600 max-w-2xl leading-relaxed">
            S&amp;B Technologies develops and supports software concepts and platforms across
            advisory suites, media networks, marketplaces, and vertical SaaS.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SOFTWARE_PRODUCTS.map((p, i) => (
              <div
                key={p.name}
                data-testid={`sp-card-${i}`}
                className="tracing-card p-8 flex flex-col group min-h-[200px]"
              >
                <div className="font-mono text-[0.6rem] uppercase tracking-[0.2em] text-slate-500 mb-3">
                  {p.category}
                </div>
                <h3 className="font-display text-xl font-semibold text-slate-900 group-hover:text-[#0066FF] transition-colors">
                  {p.name}
                </h3>
                <div className="mt-auto pt-6 flex items-center justify-between">
                  <span
                    className={`text-[0.65rem] font-mono uppercase tracking-[0.15em] px-2.5 py-1 border ${STAGE_COLOR[p.stage]}`}
                  >
                    {p.stage}
                  </span>
                  <span className="font-mono text-xs text-slate-400">
                    / {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <p className="mt-10 text-sm text-slate-500 max-w-3xl">
            Note — Some platforms are in development, prototype, concept, or portfolio stages.
            Inquire for current status, equity, or licensing opportunities.
          </p>
        </div>
      </section>

      <section className="py-20 border-t border-slate-100">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <SectionHeader
            align="center"
            eyebrow="Build With Us"
            title="License, partner, or co-build with S&B Technologies."
            description="Several of these concepts are open to investment, joint venture, or licensing partnerships."
          />
          <Link
            to="/contact?type=Investor%20%2F%20Partnership%20Opportunity"
            className="mt-8 btn-primary inline-flex"
            data-testid="sp-cta-btn"
          >
            Discuss Opportunities <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </>
  );
}
